export const getTextInfo = (text: string) => {
    return  {...{dangerouslySetInnerHTML: {__html: text}}}
};